import { Entity } from '../entities_engine/entity';

export const ICON_VALUES_SYSTEMS_TOKEN = Symbol('ICON_VALUES_SYSTEMS_TOKEN');

export abstract class IconValuesSystems {
  abstract renderIconValue(entity: Entity): void;
  abstract placementIconValue(entity: Entity): void;
}
